// Display Box for Notes Repeater Field Entries in Add Asset Modal

import { NoteCard } from "@components/note-card";

type NotesRepeaterBoxProps = {
  noteBody: string;
  date?: string;
  creator?: string;
};

const formatCreatorName = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1);

export const NotesRepeaterBox = ({ noteBody, date, creator }: NotesRepeaterBoxProps) => {
  return (
    <NoteCard
      noteText={noteBody}
      date={date}
      senderLabel={creator ? formatCreatorName(creator) : undefined}
      showVisibilityTag={false}
    />
  );
};
